import React, { useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useCondoNavItems, getCurrentCondoTab } from '../lib/condoNavItems';

function CondoNav() {
  const { condoSlug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/${condoSlug}/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const currentTab = getCurrentCondoTab(location.pathname);
  const navItems = useCondoNavItems(condoSlug);

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm mb-4">
      <div className="hidden md:flex">
        {navItems.map((item) => {
          const isActive = currentTab === item.key;
          return (
            <button
              key={item.key}
              onClick={() => navigate(`/${condoSlug}${item.path}`)}
              className={`md:flex-none flex items-center justify-center md:justify-start gap-2 px-3 md:px-6 py-4 text-sm font-medium whitespace-nowrap transition-colors border-b-2 ${
                isActive
                  ? 'border-primary text-primary bg-primary/5'
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:bg-secondary/50'
              }`}
            >
              {item.icon}
              <span className="hidden md:inline">{item.label}</span>
            </button>
          );
        })}
      </div>
      <form onSubmit={handleSearch} className="px-4 py-3 border-t-0 md:border-t border-border">
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </span>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search..."
            className="w-full pl-10 pr-4 py-2 bg-secondary/50 border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
          />
        </div>
      </form>
    </div>
  );
}

export default CondoNav;
